// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"38c7ae6f","295":"ce8be70c","356":"ba279dbb","730":"20959022","757":"2984dd90","786":"422c6542","849":"2984dd90"}[chunkId] + ".chunk.css";
};